import { TObjectShareResponse } from "../../../services/api/instances/storageApi/types/service_types";
import { createDefaultDate } from "../../../shared/utils/createDefaultDate";

export const generateNewPermissionBlock = (
  id: string,
): TObjectShareResponse[] => {
  return [
    {
      username: [],
      valid_till: createDefaultDate({ months: 1 }).toISOString(),
      write: false,
      active: true,
      id: Date.now() + Math.floor(Math.random() * 1000),
      object_id: Number(id),
      permission_pairs: [],
    },
  ];
};
